export const redirect = (uri: string, newTarget = true) => {
	window.open(uri, newTarget ? '_blank' : '_self')?.focus();
};

export const redirectToChromeStore = () =>
	redirect('https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn');

export const redirectToRampNetwork = () => redirect('https://ramp.network/buy/?defaultAsset=MATIC_USDC');
